export var DashboardSortField;
(function (DashboardSortField) {
    DashboardSortField["DASHBOARD_SORT_FIELD_CREATED_AT"] = "createdAt";
    DashboardSortField["DASHBOARD_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    DashboardSortField["DASHBOARD_SORT_FIELD_NAME"] = "name";
})(DashboardSortField || (DashboardSortField = {}));
